/**
 * question: How much have you improved your business model during the program on a scale of 1 (very low) to 7 (very high)?
 * == final
 * biz_mod_improved_t1
 * 
 * @param props 
 * @returns 
 */
export const businessModelImprovementTotalCalculation = (props: any) => {
    const data = props.finalSubmissions.reduce((acc: {sum: number, count: number}, submission: any) => {
        const rate = +submission.biz_mod_improved_t1 || 0;

        if (rate) {
            acc.sum += rate;
            acc.count++;
        }

        return acc;
    }, {sum: 0, count: 0});

    return data.sum / data.count;
}